import React from 'react'
import { Trans } from '@lingui/react'

import './promo-gifts.styl'

import urlFor, { QueryParams } from 'shared/tools/url-helper'
import SVGInline from 'react-svg-inline'
import GiftIcon from 'client/shared/icons/gift.svg'

export const PromoGifts: React.FC<{ query?: QueryParams }> = ({ query }) => (
  <div className="promo-gifts">
    <img className="promo-gifts__pic" src={`${ASSETS_PATH}share.png`} alt="" />
    <a className="promo-gifts__link" href={urlFor.gifts(query)}>
      <SVGInline className="promo-gifts__icon" svg={GiftIcon} />
      <span className="promo-gifts__text">
        <Trans id="promo.gifts" />
      </span>
      <span
        className="promo-gifts__text promo-gifts__text_with-hover"
        href={urlFor.gifts(query)}
      >
        <Trans id="promo.gifts_button" />
        &nbsp;→
      </span>
    </a>
  </div>
)
